<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in shadow-none">
        <div class="card-body p-3">
          <!-- Header section -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-4">
            <div>
              <h1 class="card-title mb-1">Expense Management</h1>
              <span class="sub-text">Monitor field reimbursements and operational costs</span>
            </div>

            <button class="btn btn-soft-primary" routerLink="/expenses/travel-reports">
              <i class="bi bi-map me-2"></i>
              <span>Employee Daily Travel Reports</span>
            </button>
          </div>

          <!-- Export Expenses -->
          <div class="card bg-light p-3 mb-4">
            <div class="d-flex align-items-center gap-2 mb-2">
              <span class="fw-semibold small">Export Expenses</span>
            </div>
            <div class="row g-2 align-items-end">
              <div class="col-12 col-lg-3 ps-0">
                <label class="form-label small text-muted mb-1">Employee</label>
                <ng-select
                  placeholder="All Employees"
                  [items]="employeeList"
                  [(ngModel)]="exportFilters.employee_id"
                  bindValue="id"
                  bindLabel="full_name"
                  [clearable]="true"
                  [searchable]="true" />
              </div>
              <div class="col-6 col-lg-3">
                <label class="form-label small text-muted mb-1">From Date</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="exportFilters.from_date" />
              </div>
              <div class="col-6 col-lg-3">
                <label class="form-label small text-muted mb-1">To Date</label>
                <input type="date" class="form-control form-control-sm" [(ngModel)]="exportFilters.to_date" />
              </div>
              <div class="col-12 col-lg-3 pe-0">
                <div>
                  <button
                    class="btn btn-soft-primary w-100"
                    (click)="onExportExpenses()"
                    [disabled]="isExportingExpenses">
                    @if (isExportingExpenses) {
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                      Exporting...
                    } @else {
                      <i class="bi bi-download"></i>
                      Export
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Modern Filters Bar -->
          <div class="bg-light p-3 border mb-4">
            <div class="row g-3">
              <div class="col-lg-3 col-md-4">
                <label class="form-label small fw-bold text-muted">Employee</label>
                <ng-select
                  placeholder="All Employees"
                  [items]="employeeList"
                  [(ngModel)]="filters.employee"
                  bindValue="id"
                  bindLabel="full_name"
                  [clearable]="true"
                  [searchable]="true" />
              </div>

              <div class="col-lg-2 col-md-4">
                <label class="form-label small fw-bold text-muted">Status</label>
                <ng-select
                  placeholder="All Statuses"
                  [items]="statusOptions"
                  [(ngModel)]="filters.status"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="true"
                  [searchable]="false" />
              </div>

              <div class="col-lg-2 col-md-4">
                <label class="form-label small fw-bold text-muted">Category</label>
                <ng-select
                  placeholder="All Categories"
                  [items]="categoryOptions"
                  [(ngModel)]="filters.category"
                  bindValue="value"
                  bindLabel="label"
                  [clearable]="true"
                  [searchable]="false" />
              </div>

              <div class="col-lg-4 col-md-8">
                <label class="form-label small fw-bold text-muted">Date Range</label>
                <div class="input-group">
                  <input type="date" class="form-control" [(ngModel)]="filters.from_date" />
                  <span class="input-group-text bg-white text-muted small">to</span>
                  <input type="date" class="form-control" [(ngModel)]="filters.to_date" />
                </div>
              </div>

              <div class="col-lg-1 col-md-4 d-flex align-items-end">
                <button class="btn btn-primary w-100" (click)="applyFilters()">
                  <i class="bi bi-search"></i>
                </button>
              </div>
            </div>
          </div>

          @if (!isDataLoading) {
            <!-- Expense Summary Cards -->
            <div class="row g-3 mb-4">
              @for (card of summaryCards; track card.key) {
                <div
                  class="col-12 col-md-4"
                  [class.ps-0]="$index === 0"
                  [class.pe-0]="$index === summaryCards.length - 1">
                  <app-expense-summary-card
                    [icon]="card.icon"
                    [iconColor]="card.iconColor"
                    [borderColor]="card.borderColor"
                    [label]="card.label"
                    [amount]="expensesSummary?.[card.key]?.total_amount ?? 0"
                    [count]="expensesSummary?.[card.key]?.request_count ?? 0" />
                </div>
              }
            </div>

            <!-- Expenses List Section -->
            <div class="col-12 px-0">
              <div class="card p-0 animate-fade-in border-0">
                <div class="card-body px-0">
                  <h5 class="fw-800 mb-4">Expense Requests History</h5>

                  @if (isApplyingFilter) {
                    <app-loading-spinner message="Filtering records..."></app-loading-spinner>
                  } @else {
                    @if ((expensesList || []).length === 0) {
                      <div class="text-center py-5">
                        <div class="bg-light d-inline-block p-4 rounded-circle mb-3">
                          <i class="bi bi-receipt text-muted fs-1"></i>
                        </div>
                        <h5 class="text-dark fw-bold">No Expenses Logged</h5>
                        <p class="text-muted">There are no expense records matching your current filters.</p>
                      </div>
                    } @else {
                      <div class="table-responsive">
                        <table class="table table-hover align-middle mb-0">
                          <thead class="bg-light">
                            <tr>
                              <th class="ps-4 border-0 text-uppercase small fw-bold text-muted py-3">Team Member</th>
                              <th class="border-0 text-uppercase small fw-bold text-muted py-3">Category</th>
                              <th class="border-0 text-uppercase small fw-bold text-muted py-3">Amount</th>
                              <th class="border-0 text-uppercase small fw-bold text-muted py-3">Date</th>
                              <th class="border-0 text-uppercase small fw-bold text-muted py-3">Status</th>
                              <th class="pe-4 border-0 text-uppercase small fw-bold text-muted py-3 text-end">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (expense of expensesList; track expense.id) {
                              <tr class="cursor-pointer transition-all border-bottom" (click)="onViewExpense(expense)">
                                <td class="ps-4 py-3">
                                  <div class="d-flex align-items-center">
                                    <div
                                      class="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold"
                                      style="width: 32px; height: 32px; font-size: 12px">
                                      {{ expense.employee.user.first_name.charAt(0)
                                      }}{{ expense.employee.user.last_name.charAt(0) }}
                                    </div>
                                    <div class="ms-3">
                                      <div class="fw-bold text-dark">
                                        {{ expense.employee.user.first_name + ' ' + expense.employee.user.last_name }}
                                      </div>
                                      <div class="text-xs text-muted">ID: {{ expense.employee.employee_number }}</div>
                                    </div>
                                  </div>
                                </td>
                                <td class="py-3">
                                  <span class="app-badge badge-primary">
                                    {{ expense.category | titlecase }}
                                  </span>
                                </td>
                                <td class="py-3">
                                  <div class="fw-800 text-dark">₹{{ expense.amount }}</div>
                                </td>
                                <td class="py-3">
                                  <span class="text-muted small">
                                    <i class="bi bi-calendar-event me-1"></i>
                                    {{ expense.date_of_expense | date: 'dd MMM yyyy' }}
                                  </span>
                                </td>
                                <td class="py-3">
                                  <span
                                    class="app-badge"
                                    [ngClass]="{
                                      'badge-warning': expense.status === ExpenseStatus.PENDING,
                                      'badge-success': expense.status === ExpenseStatus.APPROVED,
                                      'badge-danger': expense.status === ExpenseStatus.REJECTED,
                                    }">
                                    {{ expense.status | titlecase }}
                                  </span>
                                </td>
                                <td class="pe-4 py-3 text-end" (click)="$event.stopPropagation()">
                                  <div class="d-flex gap-2 justify-content-end">
                                    <button
                                      class="btn btn-action-info"
                                      (click)="onViewExpense(expense)"
                                      title="View Details">
                                      <i class="bi bi-eye"></i>
                                    </button>
                                    @if (expense.status === ExpenseStatus.PENDING) {
                                      <button
                                        class="btn btn-action-info"
                                        (click)="openExpenseActionModal(expense)"
                                        title="Approve/Reject">
                                        <i class="bi bi-shield-check"></i>
                                      </button>
                                    }
                                  </div>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </div>

                      <div class="mt-4">
                        <app-pagination
                          [currentPage]="currentPage"
                          [totalCount]="totalCount"
                          [pageSize]="10"
                          [hasNextPage]="hasNextPage"
                          [hasPreviousPage]="hasPreviousPage"
                          (pageChange)="onPageChange($event)"></app-pagination>
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
          }
          @if (isDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Expense Details Modal -->
<ng-template #expenseDetailsModal let-modal>
  <div class="modal-content border-0 overflow-hidden">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold">Expense Voucher</h5>
        <div class="text-muted small">Reference ID: {{ selectedExpense?.id?.slice(-8) }}</div>
      </div>
      <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body">
      <div class="row g-4">
        <div class="col-lg-6">
          <div class="bg-light p-4 h-100 border">
            <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-4">Request Information</h6>

            <div class="mb-3 d-flex justify-content-between align-items-center">
              <span class="text-muted small">Employee</span>
              <span class="fw-bold">
                {{ selectedExpense?.employee?.user?.first_name }} {{ selectedExpense?.employee?.user?.last_name }}
              </span>
            </div>

            <div class="mb-3 d-flex justify-content-between align-items-center">
              <span class="text-muted small">Category</span>
              <span class="app-badge badge-primary">{{ selectedExpense?.category | titlecase }}</span>
            </div>

            <div class="mb-3 d-flex justify-content-between align-items-center">
              <span class="text-muted small">Expense Date</span>
              <span class="fw-bold">{{ selectedExpense?.date_of_expense | date: 'longDate' }}</span>
            </div>

            <div class="bg-white p-3 border mb-3 d-flex justify-content-between align-items-center">
              <span class="text-muted small">Claimed Amount</span>
              <span class="fs-4 fw-bold text-success">₹{{ selectedExpense?.amount }}</span>
            </div>

            <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-2">Description</h6>
            <p class="text-dark bg-white p-3 rounded-3 border small">
              {{ selectedExpense?.description || 'No description provided.' }}
            </p>
          </div>
        </div>

        <div class="col-lg-6">
          <div
            class="receipt-preview text-center h-100 d-flex flex-column align-items-center justify-content-center border bg-light p-4">
            @if (selectedExpense?.receipt) {
              <h6 class="text-uppercase small fw-800 text-muted letter-spacing-1 mb-3 w-100 text-start">
                Digital Receipt
              </h6>
              <img [src]="selectedExpense?.receipt" class="img-fluid rounded-3 shadow-sm border" alt="Receipt" />
              <a
                [href]="selectedExpense?.receipt"
                target="_blank"
                class="btn btn-link btn-sm mt-3 text-primary text-decoration-none fw-bold">
                <i class="bi bi-zoom-in me-1"></i>
                View Full Image
              </a>
            } @else {
              <div class="p-5 text-muted opacity-50">
                <i class="bi bi-image fs-1 d-block mb-3"></i>
                <p class="small fw-bold">No receipt image attached</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="modal-footer p-3">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
  </div>
</ng-template>

<!-- Action Modal -->
<ng-template #expenseActionModal let-modal>
  <div class="modal-content border-0 overflow-hidden shadow-lg" style="max-width: 400px; margin: auto">
    <div class="modal-body p-5 text-center">
      <div class="bg-primary bg-opacity-10 text-primary d-inline-block p-4 rounded-circle mb-4">
        <i class="bi bi-shield-check fs-1"></i>
      </div>
      <h4 class="fw-800 text-dark mb-2">Process Request</h4>
      <p class="text-muted mb-4">
        Verify the receipt and details before making a final decision on this expense claim.
      </p>

      <div class="d-grid gap-2">
        <button
          class="btn btn-success py-3 rounded-3 fw-bold shadow-sm"
          (click)="confirmExpenseAction(ExpenseStatus.APPROVED, modal)">
          <i class="bi bi-check2-circle me-2"></i>
          Approve Reimbursement
        </button>
        <button
          class="btn btn-outline-danger py-3 rounded-3 fw-bold border-0"
          (click)="confirmExpenseAction(ExpenseStatus.REJECTED, modal)">
          <i class="bi bi-x-circle me-2"></i>
          Reject Request
        </button>
      </div>
      <button class="btn btn-link btn-sm text-muted mt-3 text-decoration-none" (click)="modal.dismiss()">
        Cancel and Review Later
      </button>
    </div>
  </div>
</ng-template>
